"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Error503;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _utils = require("./utils");

var _react = _interopRequireDefault(require("react"));

function Error503(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: "143.1",
    height: "94"
  }, (0, _utils.getIllustrationProps)(props)), /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(-416.2 -3367.5)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "18.1",
    cy: "18.1",
    r: "18.1",
    transform: "translate(417.7 3396.9)",
    strokeWidth: "3"
  }), /*#__PURE__*/_react.default.createElement("path", {
    strokeWidth: "3",
    d: "M423.4 3402.2l24.5 24.4M435.8 3390v-19a2.006 2.006 0 012-2h118a2.006 2.006 0 012 2v23a2.006 2.006 0 01-2 2h-104M457.8 3401h98a2.006 2.006 0 012 2v23a2.006 2.006 0 01-2 2h-97M452.8 3433h103a2.006 2.006 0 012 2v23a2.006 2.006 0 01-2 2h-118a2.006 2.006 0 01-2-2v-18M546.8 3429v3M546.8 3397v3"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "4",
    cy: "4",
    r: "4",
    transform: "translate(542.8 3378.5)",
    strokeWidth: "2"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "4",
    cy: "4",
    r: "4",
    transform: "translate(542.8 3411)",
    strokeWidth: "2"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "4",
    cy: "4",
    r: "4",
    transform: "translate(542.8 3442.5)",
    strokeWidth: "2"
  })));
}